import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

type LessonTemplatesType = {
  zeroLessonTemplateLesson: null;
  lessonTemplateId: string | null;
  lessonTemplateTab: 0;
  lessonTemplate: null;
  teacherLessonTemplates: [];
  selectedLessonTemplate: null;
  isResetLessonTemplateForm: boolean;
  isLessonTemplatesLoading: boolean;
  isEditNewLessonTemplateMode: boolean;
  lessonTemplates: [];
};

const initialState: LessonTemplatesType = {
  zeroLessonTemplateLesson: null,
  lessonTemplateId: null,
  lessonTemplate: null,
  lessonTemplateTab: 0,
  isResetLessonTemplateForm: false,
  isEditNewLessonTemplateMode: false,
  isLessonTemplatesLoading: false,
  selectedLessonTemplate: null,
  teacherLessonTemplates: [],
  lessonTemplates: [],
};

export const lessonTemplatesSlice = createSlice({
  name: 'lessonTemplates',
  initialState,
  reducers: {
    setZeroLessonTemplateLesson: (state, action: PayloadAction<[]>) => {
      state.zeroLessonTemplateLesson = action.payload;
    },
    setIsEditNewLessonTemplateMode: (state, action: PayloadAction<[]>) => {
      state.isEditNewLessonTemplateMode = action.payload;
    },
    setLessonTemplateId: (state, action: PayloadAction<string | null>) => {
      state.lessonTemplateId = action.payload;
    },
    setLessonTemplateTab: (state, action: PayloadAction<[]>) => {
      state.lessonTemplateTab = action.payload;
    },
    setLessonTemplate: (state, action: PayloadAction<[]>) => {
      state.lessonTemplate = action.payload;
    },
    setIsLessonTemplatesLoading: (state, action: PayloadAction<[]>) => {
      state.isLessonTemplatesLoading = action.payload;
    },
    setSelectedLessonTemplate: (state, action: PayloadAction<[]>) => {
      state.selectedLessonTemplate = { ...action.payload };
    },
    setIsResetLessonTemplateForm: (state, action: PayloadAction<[]>) => {
      state.isResetLessonTemplateForm = action.payload;
    },
    setLessonTemplates: (state, action: PayloadAction<[]>) => {
      state.lessonTemplates = action.payload;
    },
    setTeacherLessonTemplates: (state, action: PayloadAction<[]>) => {
      state.teacherLessonTemplates = action.payload;
    },
  },
});

export const {
  setZeroLessonTemplateLesson,
  setSelectedLessonTemplate,
  setLessonTemplateId,
  setIsEditNewLessonTemplateMode,
  setIsResetLessonTemplateForm,
  setLessonTemplateTab,
  setIsLessonTemplatesLoading,
  setLessonTemplate,
  setLessonTemplates,
  setTeacherLessonTemplates,
} = lessonTemplatesSlice.actions;
